import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";

const DiscrepanciesDetails = () => {
  const location = useLocation();
  const { row } = location.state || {};

  if (!row) {
    return <Typography>No data provided.</Typography>;
  }

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleString();
    } catch {
      return "N/A";
    }
  };

  return (
    <Card sx={{ maxWidth: "95%", margin: "auto", mt: 4, p: 2 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* Settlement Info */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography><strong>Settlement ID:</strong> {row?.settlementId || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Status:</strong> {row?.settlementStatus || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Type:</strong> {row?.type || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Reconciliation Initiated:</strong> {row?.reconcilationInitiated ? "Yes" : "No"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Collector App ID:</strong> {row?.collectorAppId || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Receiver App ID:</strong> {row?.receiverAppId || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Created At:</strong> {formatDate(row?.createdAt)}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Updated At:</strong> {formatDate(row?.updatedAt)}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Orders */}
        <Typography variant="h6">Orders</Typography>
        {row?.orders?.length > 0 ? (
          row.orders.map((order, index) => (
            <Box key={index} sx={{ my: 1, pl: 2, borderLeft: "2px solid #ccc" }}>
              <Typography><strong>Order ID:</strong> {order?.id || "N/A"}</Typography>
              <Typography>
                <strong>Collector Amount:</strong> ₹{order?.collector?.amount?.value || "0"} {order?.collector?.amount?.currency || ""}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography>No orders found.</Typography>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Discrepancies */}
        <Typography variant="h6">Discrepancies</Typography>
        {row?.discrepancies?.length > 0 ? (
          row.discrepancies.map((d, index) => (
            <Box key={index} sx={{ my: 1, pl: 2, borderLeft: "2px solid #f00" }}>
              <Typography><strong>ID:</strong> {d?.id || "N/A"}</Typography>
              <Typography>
                <strong>Settled Amount:</strong> ₹{d?.settled_amount?.value || "0"} {d?.settled_amount?.currency || ""}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography>No discrepancies found.</Typography>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Provider Info */}
        {row?.provider && (
          <>
            <Typography variant="h6">Provider</Typography>
            <Box sx={{ my: 1, pl: 2, borderLeft: "2px solid #4caf50" }}>
              <Typography><strong>ID:</strong> {row?.provider?.id || "N/A"}</Typography>
              <Typography><strong>Name:</strong> {row?.provider?.name || "N/A"}</Typography>
              <Typography>
                <strong>Amount:</strong> ₹{row?.provider?.amount?.value || "0"} {row?.provider?.amount?.currency || ""}
              </Typography>
              <Typography>
                <strong>Bank:</strong> {row?.provider?.bank_details?.account_no || "N/A"} ({row?.provider?.bank_details?.ifsc_code || "N/A"})
              </Typography>
            </Box>
          </>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Self Info */}
        {row?.orders?.[0]?.self && (
          <>
            <Typography variant="h6">Self</Typography>
            <Box sx={{ my: 1, pl: 2, borderLeft: "2px solid #2196f3" }}>
              <Typography>
                <strong>Amount:</strong> ₹{row?.orders?.[0]?.self?.amount?.value || "0"} {row?.orders?.[0]?.self?.amount?.currency || ""}
              </Typography>
              <Typography><strong>Status:</strong> {row?.orders?.[0]?.self?.status || "N/A"}</Typography>
              <Typography><strong>Reference No:</strong> {row?.orders?.[0]?.self?.reference_No || "N/A"}</Typography>
            </Box>
          </>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Context */}
        {row?.context && (
          <>
            <Typography variant="h6">Context</Typography>
            <Box sx={{ my: 1, pl: 2, borderLeft: "2px solid #9c27b0" }}>
              <Typography><strong>Domain:</strong> {row?.context?.domain || "N/A"}</Typography>
              <Typography><strong>Version:</strong> {row?.context?.version || "N/A"}</Typography>
              <Typography><strong>BAP ID:</strong> {row?.context?.bap_id || "N/A"}</Typography>
              <Typography><strong>BPP ID:</strong> {row?.context?.bpp_id || "N/A"}</Typography>
              <Typography>
                <strong>Location:</strong>{" "}
                {row?.context?.location?.country?.code || "N/A"},{" "}
                {row?.context?.location?.city?.code || "N/A"}
              </Typography>
              <Typography><strong>Message ID:</strong> {row?.context?.message_id || row?.message_id || "N/A"}</Typography>
              <Typography><strong>Transaction ID:</strong> {row?.context?.transaction_id || row?.transaction_id || "N/A"}</Typography>
            </Box>
          </>
        )}

        {/* Back button */}
        <Box sx={{ mb: 2, mt: 4 }}>
          <Button
            component={Link}
            to="/app/management/discrepancies-list"
            variant="outlined"
            color="primary"
          >
            Back
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DiscrepanciesDetails;
